import { Injectable, inject } from '@angular/core';
import { RightBridgeApiService } from '../../services/right-bridge-api.service';
import { Observable, of } from 'rxjs';
import { sampleUsers } from './sample-user';
import { RepData, UserData } from '../../models/admin-models';
import { ResultString } from '../../models/general-models';

@Injectable({ providedIn: 'root' })
export class UserManagementService {
  private rbs = inject(RightBridgeApiService);

  getRepCodes(): Observable<any> {
    return this.getRepHierarchy();
  }
  getUnits(): Observable<any> {
    return this.getUnitHierarchy();
  }
  getUnitHierarchy(): Observable<any> {
    return this.rbs.getRequest<any>(
      `${this.rbs.baseUrl}/Hierarchy/Unit?SearchString=`
    );
  }

  getRepHierarchy(searchString = '', maxRows = 20): Observable<any> {
    return this.rbs.getRequest<any>(
      `${this.rbs.baseUrl}/Hierarchy/RepCode?searchString=${searchString}&maxRows=${maxRows}`
    );
  }

  searchReps(
    searchTerms: object,
    start = 0
  ): Observable<{ repcodes: RepData[] }> {
    return this.rbs.getRequest<{ repcodes: RepData[] }>(
      `${this.rbs.baseUrl}/AppAdmin/SearchReps/?repcode=${
        searchTerms['repcode'] || ''
      }&name=${searchTerms['name'] || ''}&unitname=${
        searchTerms['unitname'] || ''
      }&unitid=${searchTerms['unitid'] || ''}&start=${start}`
    );
  }

  searchUsers(
    searchTerms: object,
    start = 0
  ): Observable<{ users: UserData[] }> {
    return this.rbs.getRequest<{ users: UserData[] }>(
      `${this.rbs.baseUrl}/AppAdmin/Advisors?firstname=${
        searchTerms['firstName'] || ''
      }&lastname=${searchTerms['lastName'] || ''}&username=${
        searchTerms['username'] || ''
      }&unit=${searchTerms['unit'] || ''}&repcode=${
        searchTerms['repcode'] || ''
      }&id=${searchTerms['id'] || ''}&role=${
        searchTerms['role'] || ''
      }&saveType=${searchTerms['saveType'] || 'Any'}&start=${start}`
    );
  }

  userInfo(userid: string): Observable<string> {
    return this.rbs.getRequestText(
      `${this.rbs.baseUrl}/AppAdmin/UserInfo/?id=${userid}`
    );
  }

  advisorLookahead(username: object): Observable<{ users: UserData[] }> {
    return this.rbs.getRequest<{ users: UserData[] }>(
      `${this.rbs.baseUrl}/AppAdmin/AdvisorLookAhead/?username=${username}&includeAllUsers=true`
    );
  }

  add(user: object): Observable<void> {
    let headers = this.rbs.baseHeaders();
    headers = headers.set('Content-Type', 'application/json');
    return this.rbs.postRequest<void>(
      `${this.rbs.baseUrl}/AppAdmin/Advisors`,
      JSON.stringify(user),
      headers
    );
  }

  addRep(rep: object): Observable<void> {
    let headers = this.rbs.baseHeaders();
    headers = headers.set('Content-Type', 'application/json');
    return this.rbs.postRequest<void>(
      `${this.rbs.baseUrl}/AppAdmin/AddRep/?repcode=${rep['repcode']}&name=${rep['name']}&unitid=${rep['unitid']}`,
      headers
    );
  }

  updateRep(rep: object): Observable<void> {
    let headers = this.rbs.baseHeaders();
    headers = headers.set('Content-Type', 'application/json');
    return this.rbs.postRequest<void>(
      `${this.rbs.baseUrl}/AppAdmin/UpdateRep/?repcode=${rep['repCode']}&name=${rep['repName']}&unitid=${rep['UnitId']}&active=${rep['Active']}`,
      headers
    );
  }

  update(user: object): Observable<void> {
    let headers = this.rbs.baseHeaders();
    headers = headers.set('Content-Type', 'application/json');
    return this.rbs.patchRequest<void>(
      `${this.rbs.baseUrl}/AppAdmin/Advisors`,
      JSON.stringify(user),
      headers
    );
  }

  remove(user: object): Observable<ResultString> {
    return this.rbs.deleteRequest<ResultString>(
      `${this.rbs.baseUrl}/AppAdmin/Advisors/?userid=${user['id']}`
    );
  }

  resetPassword(userid: string): Observable<void> {
    let headers = this.rbs.baseHeaders();
    headers = headers.set('X-RB-U', userid);
    return this.rbs.getRequest<void>(
      `${this.rbs.baseUrl}/Admin/resetpassword`,
      headers
    );
  }
}
